import { Card, Row, Col, DatePicker, Space, Button, Typography } from "antd";
import { FilterOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useState, useEffect } from "react";

const { RangePicker } = DatePicker;
const { Text } = Typography;

const CpdFilterToolbar = ({ filters, onFilterChange }) => {
  const [localFilters, setLocalFilters] = useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleApplyFilters = () => {
    onFilterChange(localFilters);
  };

  const handleResetFilters = () => {
    const defaultFilters = {
      dateRange: [dayjs().subtract(1, "month"), dayjs()],
    };
    setLocalFilters(defaultFilters);
    onFilterChange(defaultFilters);
  };

  const handleFilterChange = (key, value) => {
    setLocalFilters(prev => ({ ...prev, [key]: value }));
  };

  return (
    <Card
      title={
        <Space>
          <FilterOutlined />
          <Text strong>Analytics Period</Text>
        </Space>
      }
      size="small"
    >
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={8}>
            <Text type="secondary" style={{ display: "block", marginBottom: 4 }}>
              Date Range
            </Text>
            <RangePicker
              value={localFilters.dateRange}
              onChange={(dates) => handleFilterChange("dateRange", dates)}
              style={{ width: "100%" }}
              format="DD MMM YYYY"
              presets={[
                { label: "Last 7 Days", value: [dayjs().subtract(7, "days"), dayjs()] },
                { label: "Last 30 Days", value: [dayjs().subtract(30, "days"), dayjs()] },
                { label: "Last 3 Months", value: [dayjs().subtract(3, "months"), dayjs()] },
                { label: "Last 6 Months", value: [dayjs().subtract(6, "months"), dayjs()] },
                { label: "Last Year", value: [dayjs().subtract(1, "year"), dayjs()] },
              ]}
            />
          </Col>

          <Col xs={24} sm={12} lg={8} style={{ display: "flex", alignItems: "flex-end" }}>
            <Space>
              <Button type="primary" icon={<FilterOutlined />} onClick={handleApplyFilters}>
                Apply Period
              </Button>
              <Button icon={<ReloadOutlined />} onClick={handleResetFilters}>
                Reset
              </Button>
            </Space>
          </Col>
        </Row>
      </Space>
    </Card>
  );
};

export default CpdFilterToolbar;
